
import React from 'react';

interface OfferPageInfoProps {
  offerId: string;
  productCount: number;
}

const OfferPageInfo: React.FC<OfferPageInfoProps> = ({ offerId, productCount }) => {
  return (
    <p className="text-sm text-gray-400 mt-2">
      (Offer ID: {offerId}, 
      {productCount ? ` ${productCount} product(s) attached` : ' No products attached'})
    </p>
  );
};

export default OfferPageInfo;
